var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageErrorUser = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 47.5,
    r: 46.5,
    stroke: "#D34F6F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 52.8889L58 59M58 52.8889L51.75 59M38 59C38 54.2749 41.9175 50.4444 46.75 50.4444C46.9601 50.4444 47.1686 50.4517 47.375 50.4659M51.75 41.8889C51.75 44.5889 49.5114 46.7778 46.75 46.7778C43.9886 46.7778 41.75 44.5889 41.75 41.8889C41.75 39.1888 43.9886 37 46.75 37C49.5114 37 51.75 39.1888 51.75 41.8889Z",
    stroke: "#D34F6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageErrorUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/message_error_user.60fe22bf83e1a110a7467707d15d6728.svg";